import React from 'react'
import './ImageStyleSheet.css';

function RogerFour() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/roger4.jpeg" className='img-view'/>
        </div>
    )
}

export default RogerFour
